import { ChartState } from '@shopify/polaris-viz-core';
import { Component } from 'react';
import { checkForMismatchedData } from './utilities/checkForMismatchedData.js';
import { jsx } from 'react/jsx-runtime';
import { ChartSkeleton } from '../ChartSkeleton/ChartSkeleton.js';

class ChartErrorBoundary extends Component {
  static getDerivedStateFromError(_) {
    return {
      hasError: true
    };
  }

  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };

    this.onError = (error, errorInfo) => {
      checkForMismatchedData(this.props.data);

      if (this.props.onError) {
        this.props.onError(error, errorInfo);
      } else {
        // eslint-disable-next-line no-console
        console.error({
          error,
          errorInfo
        });
      }
    };
  }

  componentDidCatch(error, errorInfo) {
    this.onError(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return /*#__PURE__*/jsx(ChartSkeleton, {
        type: this.props.type,
        state: ChartState.Error,
        dimensions: this.props.dimensions
      });
    }

    return this.props.children;
  }

}

export { ChartErrorBoundary };
